// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"ce787b65","453":"5a3ebcae"}[chunkId] + ".chunk.js";
};